export const EVENT_NAMES = {
  auth: 'onb:auth',
  headers: 'onb:headers',
  loader: 'onb:loader',
  onIsClient: 'onb-mfa-login:-on-is-client',
  loginConfig: 'onb-mfa-login:config',
  loginOnAuthenticate: 'onb-mfa-login:on-authenticate',
  facephiConfig: 'onb-mfa-facephi:config',
  facephiPath: 'onb-mfa-facephi:path',
  facephiOnValidateImage: 'onb-mfa-facephi:on-validate-image',
  facephiOnMaxAttempts: 'onb-mfa-facephi:on-max-attempts',
  facephiOnBack: 'onb-mfa-facephi:on-back',
  controlListConfig: 'onb-mfa-control-list:config',
  controlListOnValidateUrl: 'onb-mfa-url-validation:on-validate-url',
  controlListOnBlocked: 'onb-mfa-url-validation:on-blocked',
  controlListOnRedirectToAgency: 'onb-mfa-url-validation:on-redirect-to-agency',
  fircConfig: 'onb-mfa-firc:config',
  fircOnSubmit: 'onb-mfa-firc:on-submit',
  fircOnBack: 'onb-mfa-firc:on-back',
  fircOnBackStep: 'onb-mfa-firc:on-back-step',
  fircOnChange: 'onb-mfa-firc:on-change',
  fircOnClientStatus: 'onb-mfa-firc:on-client-status',
  debitCardOnBackStep: 'onb-mfa-debit-card:on-back-step',
  taxResidenceConfig: 'onb-mfa-tax-residence:config',
  taxResidenceOnSubmit: 'onb-mfa-tax-residence:on-submit',
  taxResidenceOnBack: 'onb-mfa-tax-residence:on-back',
  taxResidenceOnBackStep: 'onb-mfa-tax-residence:on-back-step',
  taxResidenceOnNextStep: 'onb-mfa-tax-residence:on-next-step',
  simulatorConfig: 'onb-mfa-simulator:on-config-account',
  otpConfig: 'onb-mfa-otp:config',
  otpOnBack: 'onb-mfa-otp:on-back',
  otpOnSubmit: 'onb-mfa-otp:on-submit',
  otpOnGenerate: 'onb-mfa-otp:on-generate-otp',
  summaryConfig: 'onb-mfa-summary:config',
  summaryOnBack: 'onb-mfa-summary:on-back',
  analytics: 'onb:analytics',
  insuranceConfig: 'sge-mfa-offer:config',
  cardPrince: 'onb-mfa-chl0037-debit-card-request:price'
}
